import { render } from "./MediaDocsLinksPanel.vue?vue&type=template&id=f1c068ac&scoped=true"
import script from "./MediaDocsLinksPanel.vue?vue&type=script&lang=js"
export * from "./MediaDocsLinksPanel.vue?vue&type=script&lang=js"

import "./MediaDocsLinksPanel.vue?vue&type=style&index=0&id=f1c068ac&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c068ac"]])

export default __exports__